/**
 * Phase H (Δ-13) — Status mode tabs.
 *
 * CR-0014a polish (Δ-13a, 2026-05-30):
 *  - Dropped the "All" pill. Toggling the currently-active tab clears
 *    the mode back to `null` (which is the default "show everything"
 *    state). Three tabs only: Not Arrived / Waiting / Seated.
 *  - Unified pill geometry: `rounded-md px-3 py-1 text-xs` to match
 *    `SearchField` and `CategoryFilterChips`.
 *
 * CR-0014c (Δ-13c, 2026-05-30) — pre-breakfast self-gate (C-25):
 *  - Component returns `null` when `appState.breakfast_started === false`.
 *    Mirrors the existing pattern in `CategoryFilterChips.jsx` line 25.
 *    Rationale: tabs filter on `Reserved`/`Occupied` states, neither of
 *    which can exist before service starts, so the tabs are inert
 *    pre-breakfast and previously left a hollow row next to the
 *    144px search input.
 */
import useAppStore from "@/store/useAppStore";

const MODES = [
  { id: "Not Arrived", label: "Not Arrived" },
  { id: "Waiting", label: "Waiting" },
  { id: "Seated", label: "Seated" },
];

export default function ModeTabs() {
  const breakfastStarted = useAppStore((s) => s.appState?.breakfast_started);
  const selectedMode = useAppStore((s) => s.selectedMode);
  const setSelectedMode = useAppStore((s) => s.setSelectedMode);

  // C-25: hide tabs pre-breakfast.
  if (!breakfastStarted) return null;

  return (
    <div
      data-testid="mode-tabs"
      className="flex items-center gap-1 overflow-x-auto no-scrollbar"
    >
      {MODES.map((m) => {
        const active = selectedMode === m.id;
        const testId = `mode-tab-${m.id.toLowerCase().replace(/\s+/g, "-")}`;
        return (
          <button
            key={m.id}
            data-testid={testId}
            onClick={() => setSelectedMode(active ? null : m.id)}
            className="whitespace-nowrap rounded-md px-3 py-1 text-xs font-medium transition-colors"
            style={{
              backgroundColor: active ? "#424242" : "transparent",
              border: `1px solid ${active ? "#424242" : "#E0E0E0"}`,
              color: active ? "#FFFFFF" : "#424242",
            }}
          >
            {m.label}
          </button>
        );
      })}
    </div>
  );
}
